import React from "react";
import { Link } from "react-router-dom";


const Home = () => {
  return (
    <div>
      <div class="position-relative overflow-hidden p-3 p-md-5 m-md-3 text-center bg-light">
        <div class="col-md-5 p-lg-5 mx-auto my-5">
          <h1 class="display-4 fw-normal">Nepa Youth Club</h1>
          <p class="lead fw-normal">
            We are the non-profit organization.
            <hr></hr>
            "We Rise By Lifting Others"
          </p>
          <a class="btn btn-outline-secondary" href="#">
          <Link className="nav-link" to="/news">
                News Feeds
              </Link>
          </a>
        </div>
        <div class="product-device shadow-sm d-none d-md-block"></div>
        <div class="product-device product-device-2 shadow-sm d-none d-md-block"></div>
      </div>

<div class="position-relative overflow-hidden px-3 px-md-5 mx-md-3 text-center bg-light">

      <div id="myCarousel" class="carousel slide" data-bs-ride="carousel">
    <div class="carousel-indicators">
      <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
      <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
      <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
    </div>
    <div class="carousel-inner">
      <div class="carousel-item active">
      <img class="d-block w-100" src="./img/p2.jpg" alt="First slide"/> 
      <div class="container">
          <div class="carousel-caption text-center">
            <h1>Gallary</h1>
            <p>Some Programs conducted By our Organization</p>
            <p><a class="btn btn-lg btn-primary" href="#">View Gallary</a></p>
          </div>
        </div>
      </div>
      <div class="carousel-item">
      <img class="d-block w-100" src="./img/p3.jpg" alt="First slide"/> 
      <div class="container">
          <div class="carousel-caption center">
            <h1>Gallary</h1>
            <p>Some Programs conducted By our Organization</p>
            <p><a class="btn btn-lg btn-primary" href="#">View Gallary</a></p>
          </div>
        </div>
      </div>
      <div class="carousel-item">
      <img class="d-block w-100" src="./img/p1.jpg" alt="First slide"/>      
        <div class="container">
          <div class="carousel-caption text-center">
            <h1>Gallary</h1>
            <p>Some Programs conducted By our Organization</p>
            <p><a class="btn btn-lg btn-primary" href="#">Browse gallery</a></p>
          </div>
        </div>
      </div>
    </div>
    <button class="carousel-control-prev" type="button" data-bs-target="#myCarousel" data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#myCarousel" data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>
  </div>

</div>

    </div>

  );
};

export default Home;
